// extracted by mini-css-extract-plugin
export var centerText = "_eo-8";
export var container = "_eo-0";
export var doughnutContainer = "_eo-7";
export var legend = "_eo-a";
export var legendItemColorDisplay = "_eo-b";
export var legendItemLabel = "_eo-d";
export var legendItemValue = "_eo-c";
export var lg = "_eo-5";
export var maxWidth = "_eo-9";
export var md = "_eo-4";
export var responsive = "_eo-6";
export var sm = "_eo-3";
export var xs = "_eo-2";
export var xxs = "_eo-1";